<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.members.addTitle' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'manageEvent.members.addDescription' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <!-- User Search Section -->
    <div class="row mb-4">
      <div class="col-12">
        <label class="form-label">{{ 'manageEvent.members.searchUser' | translate }} <span class="text-danger">*</span></label>
        <div class="position-relative">
          <app-input-component
            [type]="'text'"
            [placeholder]="'manageEvent.members.searchPlaceholder' | translate"
            [value]="userSearch"
            (valueChange)="onSearchInput($event)"
            [disabled]="selectedUser != null"
            [invalid]="isUserInvalid"
          />
          @if (selectedUser) {
            <div class="selected-user-badge mt-2">
              <span class="badge bg-primary d-inline-flex align-items-center gap-2">
                <i class="fa fa-user"></i>
                {{ selectedUser.full_name }}
                <i class="fa fa-times cursor-pointer" (click)="clearSelectedUser()"></i>
              </span>
            </div>
          }
          @if (showResults && userSearchResults.length > 0) {
            <div class="search-results-dropdown">
              @for (user of userSearchResults; track user.user_id) {
                <div class="search-result-item" (click)="selectUser(user)">
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-32px me-2">
                      <span class="symbol-label bg-light-primary text-primary fw-bold">
                        {{ user.first_name?.charAt(0) || '?' }}
                      </span>
                    </div>
                    <div>
                      <div class="fw-medium">{{ user.full_name }}</div>
                      <small class="text-muted">{{ user.email }}</small>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (isSearching) {
            <div class="search-loading">
              <i class="fa fa-spinner fa-spin"></i> {{ 'common.searching' | translate }}
            </div>
          }
          @if (showResults && userSearchResults.length === 0 && !isSearching && userSearch.length >= 2) {
            <div class="search-no-results">
              {{ 'manageEvent.members.noUsersFound' | translate }}
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Access Level Section -->
    <div class="row">
      <div class="col-12">
        <label class="form-label">{{ 'manageEvent.coOrganisers.selectAccessLevel' | translate }} <span class="text-danger">*</span></label>
        <div class="d-flex flex-column gap-3">
          @for (option of accessLevelOptions; track option.value) {
            <div
              class="access-level-option p-3 rounded border cursor-pointer"
              [class.border-primary]="accessLevel === option.value"
              [class.bg-light-primary]="accessLevel === option.value"
              (click)="accessLevel = option.value"
            >
              <div class="d-flex align-items-start">
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    [id]="'member-access-' + option.value"
                    [value]="option.value"
                    [(ngModel)]="accessLevel"
                    name="accessLevel"
                  >
                </div>
                <div>
                  <label [for]="'member-access-' + option.value" class="form-label mb-1 fw-semibold cursor-pointer">
                    {{ option.label | translate }}
                  </label>
                  <p class="text-muted small mb-0">{{ option.description | translate }}</p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'neutral'"
          [label]="'common.cancel' | translate"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : ('manageEvent.members.addMember' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
